import { render, staticRenderFns } from "./Home-user.vue?vue&type=template&id=6bfa327e"
import script from "./Home-user.vue?vue&type=script&lang=js"
export * from "./Home-user.vue?vue&type=script&lang=js"
import style0 from "./Home-user.vue?vue&type=style&index=0&id=6bfa327e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports